<template>
  <div>
    <div>
      <topBanner/>
    </div>

    <div style="width:100%;">

      <strategy-title></strategy-title>


    </div>


  </div>
</template>

<script>
import topBanner from "@/components/topBanner/topBanner";
import strategyTitle from "@/components/strategy/strategyTitle";
import router from "@/router";

export default {
  name: 'strategy',
  components: {topBanner, strategyTitle},
  data() {
    return {}
  },
  methods: {
  },
  mounted() {
  }
}
</script>
<style scoped>


</style>
